import React from "react";

interface WsmOneLineProps {
  children: string;
  /**
   * A ceiling only, never a floor: a floor makes the clipped box wider than the
   * cell the table handed it, and the name then paints over the column to its
   * right. The table's own auto layout decides how much each column gets.
   */
  maxWidth?: number;
}

/**
 * A cell that cannot grow the row. Parts names on this fleet run to ten words
 * ("WCF Fuel Filter Delete Kit for 2011-2016 Ford 6.7L Power Stroke"), and one
 * wrapped name turned a 48px fees row into a 200px one at 1024. The whole name
 * stays in the title attribute, so nothing is lost, only clipped.
 */
export const WsmOneLine = ({ children, maxWidth = 360 }: WsmOneLineProps) => (
  <div
    title={children}
    style={{
      maxWidth,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}
  >
    {children}
  </div>
);

export default WsmOneLine;
